import {NgModule} from '@angular/core';
import {RouterModule,Routes} from '@angular/router';
import { NavbarComponent } from './navbar.component';

const routes:Routes=[
    {path:"",component:NavbarComponent}
];

@NgModule({
    exports:[RouterModule],
    imports:[RouterModule.forChild(routes)]
})
export class NavbarRoutingModule{

}